import { getCounter } from 'components/shared/DeviceChart';

const defaultScaleKeys = ['x', 'y'];

export function getNextCounters(datasets, prevCounters) {
  let nextCounters = prevCounters;
  const prevCountersMap = prevCounters.reduce((acc, counter) => acc.set(counter.name, counter), new Map());
  const prevCountersNames = Array.from(prevCountersMap.keys());
  const currCountersNames = Array.from(datasets.reduce((acc, dataset) => acc.add(dataset.key), new Set()));
  const { same, removed, added } = compare(prevCountersNames, currCountersNames);

  if (removed.length > 0) {
    nextCounters = same.map((name) => prevCountersMap.get(name));
  }

  if (added.length > 0) {
    nextCounters = nextCounters.concat(added.map(createCounter));
  }

  return nextCounters;
}

export function getNextScales(datasets, prevScales) {
  let nextScales = prevScales;
  const prevScalesMap = prevScales.reduce((acc, prevScale) => acc.set(prevScale.key, prevScale), new Map());
  const prevScalesKeys = Array.from(prevScalesMap.keys());
  const currScalesKeys = Array.from(
    datasets.reduce((acc, dataset) => acc.add(dataset.yAxis), new Set(defaultScaleKeys))
  );
  const { same, removed, added } = compare(prevScalesKeys, currScalesKeys);

  if (removed.length > 0) {
    nextScales = same.map((key) => prevScalesMap.get(key));
  }

  if (added.length > 0) {
    nextScales = nextScales.concat(added.map(createScale));
  }

  nextScales = nextScales.map((scale) => {
    const matchedData = datasets.filter(({ yAxis }) => yAxis === scale.key && scale.label);
    const newLabel =
      matchedData.length > 1 ? matchedData.map(({ label }) => label).join(', ') : matchedData?.[0]?.label || '';

    return { ...scale, label: newLabel };
  });

  return nextScales;
}

export function createDataset({ value, label }) {
  return {
    key: value,
    type: 'line',
    label: label,
    xAxis: 'x',
    yAxis: 'y'
  };
}

export function createCounter(name) {
  return getCounter({ name });
}

export function createScale(key) {
  return {
    key,
    label: '',
    position: 'right'
  };
}

export function getNextAvailableCounter(availableCounters, counters) {
  const countersMap = counters.reduce((acc, counter) => {
    acc[counter.name] = true;

    return acc;
  }, {});

  return availableCounters.find((availableCounter) => !countersMap[availableCounter.value]) ?? availableCounters[0];
}

function compare(prev, next) {
  const map = new Map();
  let all = [];
  let same = [];
  let removed = [];
  let added = [];

  for (let value of prev) {
    if (map.has(value)) {
      map.set(value, map.get(value) - 1);
    } else {
      map.set(value, -1);
    }
  }

  for (let value of next) {
    if (map.has(value)) {
      map.set(value, map.get(value) + 1);
    } else {
      map.set(value, 1);
    }
  }

  for (let [value, index] of map.entries()) {
    all.push(value);

    if (index < 0) {
      removed.push(value);
    } else if (index > 0) {
      added.push(value);
    } else {
      same.push(value);
    }
  }

  return {
    all,
    same,
    removed,
    added
  };
}
